import { render, staticRenderFns } from "./PhoneLegalDocuments.vue?vue&type=template&id=402c26b2&scoped=true"
import script from "./PhoneLegalDocuments.vue?vue&type=script&lang=js"
export * from "./PhoneLegalDocuments.vue?vue&type=script&lang=js"
import style0 from "./PhoneLegalDocuments.vue?vue&type=style&index=0&id=402c26b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c26b2",
  null
  
)

export default component.exports